/**
 * HTML 태그는 허용하되, 일반 텍스트의 꺾쇠괄호(<some-text>)는 이스케이프 처리하는 함수
 *
 * 허용되는 HTML 태그: strong, em, b, i, u, br, p, div, span, a
 * 일반 텍스트의 <이벤트>, <이벤트2> 등은 &lt;이벤트&gt;로 변환
 */
export function escapeBracketText(content: string): string {
  if (!content) return content;

  // 모든 꺾쇠괄호를 임시로 이스케이프
  let escapedContent = content.replace(/</g, '&lt;').replace(/>/g, '&gt;');

  // 허용된 HTML 태그만 다시 복원
  const tagMatches = content.match(HTML_TAG_PATTERN) || [];

  tagMatches.forEach(tag => {
    // 태그명 추출
    const tagMatch = tag.match(/<\/?([a-zA-Z][a-zA-Z0-9]*)/);
    if (!tagMatch) return;

    // 필요한 tag명을 사용
    const tagName = tagMatch[1].toLowerCase();

    // 허용된 태그인 경우에만 복원
    if (ALLOWED_HTML_TAGS.includes(tagName)) {
      const escapedTag = tag.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      escapedContent = escapedContent.replace(escapedTag, tag);
    }
  });

  return escapedContent;
}

const ALLOWED_HTML_TAGS = [
  'strong',
  'em',
  'b',
  'i',
  'u',
  'br',
  'p',
  'div',
  'span',
  'a',
];

const HTML_TAG_PATTERN = /<\/?([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>/g;
